
/* eslint-disable */
import {
  OPEN_ADD_NEW_OPTIONS_DIALOG,
  CLOSE_ADD_NEW_OPTIONS_DIALOG,
  DISABLE_ADD_NEW_OPTIONS,
  RESET_ADD_NEW_OPTIONS,
  START_ADD_NEW_OPTIONS,
  FAILURE_ADD_NEW_OPTIONS,
  SUCCESS_ADD_NEW_OPTIONS,
  DUPLICATE_ADD_NEW_OPTIONS,
  CLOSE_TOAST_ADD_NEW_OPTIONS,
} from './constants';

const INITIAL_STATE = {
  open: false,
  loading: false,
  error: false,
  messageCode: '',
  alert: '',
  alertMessage: '',
  closeDialog: false,
  mode:"",
  body: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OPEN_ADD_NEW_OPTIONS_DIALOG:
      return {
        ...state,
        open: true,
        mode: action.payload?.mode,
        body: action.payload?.body || {},
        cb: action.payload?.cb || null
      };
    case CLOSE_ADD_NEW_OPTIONS_DIALOG:
      return {
        ...state,
        open: false,
        closeDialog: true,
        ...action.payload,
      };
    case DISABLE_ADD_NEW_OPTIONS:
      return {
        ...state,
        open: false,
      };
    case RESET_ADD_NEW_OPTIONS:
      return {
        ...state,
        error: false,
        messageCode: '',
        closeDialog: false,
      };
    case START_ADD_NEW_OPTIONS:
      return {
        ...state,
        loading: true,
        ...action.payload,
      };

    case SUCCESS_ADD_NEW_OPTIONS:
      return {
        ...state,
        loading: false,
        open: false,
        alert: 'success',
        closeDialog: true,
        ...action.payload,

      };
    case FAILURE_ADD_NEW_OPTIONS:
      return {
        ...state,
        loading: false,
        error: true,

      };
    case DUPLICATE_ADD_NEW_OPTIONS:
      return {
        ...state,
        loading: false,
        error: true,
        ...action.payload,

      };
    case CLOSE_TOAST_ADD_NEW_OPTIONS:
      return {
        ...state,
        alert: 'close',
        alertMessage: '',
        ...action.payload,

      };
    default:
      return state;
  }
};
